var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as Actions from '../../actions/unsettled-bets/unsettledBets';
var initialState = {
    isLoading: false,
    detailsIsLoading: false,
    data: [],
    details: []
};
export default function unsettledBetsReducer(state, action) {
    if (state === undefined) {
        return initialState;
    }
    switch (action.type) {
        case Actions.FETCH_UNSETTLED_BETS:
            return __assign(__assign({}, state), { isLoading: true });
        case Actions.SUCCESS_FETCH_UNSETTLED_BETS:
            return __assign(__assign({}, state), { isLoading: false, data: action.data || [] });
        case Actions.FETCH_UNSETTLED_BETS_DETAILS:
            return __assign(__assign({}, state), { isLoading: true });
        case Actions.SUCCESS_FETCH_UNSETTLED_BETS_DETAILS:
            return __assign(__assign({}, state), { isLoading: false, details: action.data || [] });
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/unsettled-bets/unsettledBetsReducer.js